<template>
  <div class="plan-created-popup">
    <popup :buttons="buttons">
      <template v-slot:title>
        <div class="icon-with-title">
          <icon class="icon" icon-name="check_circle" :color="checkIconColor" fill/>
          <div class="title" v-if="isCurrentPlanOnTrack">
            <div>{{ currentPlan.name }}</div>
            <div>נוספה לרשימה</div>
          </div>
          <div class="title" v-else>
            <div>כל הכבוד על התיכנון</div>
            <div>המוקדם!</div>
          </div>
        </div>
      </template>
      <template v-slot:content>
        <div class="content-container">
          <div class="sub-title" v-if="isCurrentPlanOnTrack">
            <div>כל הכבוד על התיכנון המוקדם!</div>
            <div>אפשר לראות בתזרים החודשי איך התוכנית מתאימה ליעד רייזאפ שלך.</div>
          </div>
          <div v-else>
            <div class="sub-title">כרגע נראה שלא ישאר מספיק בצד החודש כדי לעמוד בתוכנית הזאת.</div>
            <div>אז מה אפשר לעשות?</div>
            <div>לערוך יעדים בתזרים, לשנות פרמטרים של התוכנית הצוות שלנו תמיד כאן לעזור.</div>
          </div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import BaseUi from 'base-ui';
import { mapState, mapGetters, mapActions } from 'vuex';
import Segment from '@/Segment';

export default {
  name: 'PlanCreatedPopup',
  components: {
    Popup: BaseUi.Popup,
    Icon: BaseUi.Icon,
  },
  data() {
    return {
      checkIconColor: BaseUi.Colors.riseupBlack,
    };
  },
  created() {
    Segment.trackUserGot('PlanAhead_Flow_CreatedPopup', { isAble: this.isCurrentPlanOnTrack });
  },
  computed: {
    ...mapState('planAhead', ['currentPlan', 'calculatedMonthlyAmount']),
    ...mapGetters('planAhead', ['totalPlansMonthlyAmount']),
    ...mapGetters('cashflowView', ['riseupGoal']),
    buttons() {
      return [
        {
          title: 'הבנתי, תודה',
          action: this.close,
          variant: 'neutral',
          size: 'slim',
        },
      ];
    },
    isCurrentPlanOnTrack() {
      return this.totalPlansMonthlyAmount <= this.riseupGoal;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['closeModal']),
    ...mapActions('planAhead', ['resetCurrentPlan']),
    async close() {
      await this.resetCurrentPlan();
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">
.plan-created-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  .icon {
    font-size: 70px;
    margin-top: 44px;
    margin-bottom: 10px;
  }
  .icon-with-title {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .title {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
  }
  .content-container {
    text-align: center;
    line-height: 18px;
    font-size: 14px;
  }
  .sub-title {
    font-weight: bold;
    margin-bottom: 15px;
  }
}

</style>
